module.exports = "./images/02_klarna-openbanking.jpg";